<template>
    <div>
        <table class="table table-striped">
            <thead>
            <tr>
                <th style="min-width: 60px;">序号</th>
                <th style="min-width: 190px;">最后联系时间（本人）</th>
                <th>经营人</th>
                <th style="min-width: 130px;">船名</th>
                <th style="min-width: 80px;">载重吨</th>
                <th style="min-width: 140px;">船舶定位</th>
                <th style="min-width: 90px;">空船港</th>
                <th style="min-width: 90px;">空船时间</th>
                <th>新消息</th>
                <th style="min-width: 60px;">详情</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(vessel, index) in vessels">
                <td v-text="index + 1"></td>
                <td v-text="vessel.lastContactTimeText"></td>
                <td v-text="vessel.contact.name || vessel.contact.mobile"></td>
                <td v-text="vessel.name"></td>
                <td v-text="vessel.weight"></td>
                <td>
                    <span title="GPS" class="tag-gps mr-1" v-show="vessel.useGPS">G</span>
                    <span v-text="vessel.location"></span>
                </td>
                <td v-text="vessel.ship.start"></td>
                <td v-text="dateFormat(vessel.ship.date, 'M月D日')"></td>
                <td v-html="vesselNote(vessel.lastNote)"></td>
                <td><a target="_blank" :href="vesselHref(vessel.hash)">详情</a></td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import CallLog from '../services/callLog';
    import * as moment from 'moment';

    export default {
        name: 'RecentVessels',
        data() {
            return {
                vessels: []
            };
        },
        computed: {
            dateFormat(date, formatString) {
                return (date, formatString) => date && moment(date).format(formatString);
            },
            vesselHref(hash) {
                return (hash) => `/voyage.html?hash=${hash}&origin=blank`;
            },
            vesselNote(note) {
                return (note) => {
                    if (note) {
                        var today = moment().format("YYYY-MM-DD");
                        var createTime = moment(note.createTime);
                        var content = moment(note.createTime).format("MM-DD HH:mm") + " " + note.content;
                        var html = "";
                        if (today === createTime.format("YYYY-MM-DD")) {
                            html = "<span class='c_today_message'>" + content + "</span>";
                        } else {
                            html = content;
                        }
                        if (note.referenceType === "palletDelegation") {
                            html += '<a href="/palletDelegation.html?id=' + note.referenceId + '" target="_blank">@' + note.referenceId + '</a>';
                        }
                        if (note.type === "system") {
                            html += " [系统]";
                        }
                        return html;
                    } else {
                        return "";
                    }
                };
            }
        },
        async created() {
            this.vessels = await CallLog.listRecentVessels();
        }
    }
</script>

<style scoped>
    .tag-gps {
        background: green;
        color: white;
        border-radius: 5px;
        padding: 5px;
    }
</style>

<style>
    .c_today_message {
        color: green;
        font-weight: bold;
    }
</style>
